import React, { useMemo } from 'react';
import { FiPlay } from 'react-icons/fi';
import DashboardCardGrid from '../components/DashboardCardGrid';
import { hasPermission, getSubscriptionRole } from '../subscriptionAdmin/permissions';
import { WORKFLOW_STEPS } from './config/workflowSteps';

export default function AdminSubscriptionsDashboard() {
  const role = getSubscriptionRole();

  const cardData = useMemo(() => {
    const visible = WORKFLOW_STEPS.filter(
      (step) => !step.permission || hasPermission(step.permission)
    );

    const stepCards = visible.map((step) => {
      const Icon = step.icon;
      const desc = step.description || step.subtitle;
      return {
        id: step.key,
        title: `Step ${step.id} — ${step.title}`,
        description: desc,
        path: step.path,
        icon: <Icon size={28} />,
        accent: step.accent || '#6366f1',
      };
    });

    if (visible.length > 0) {
      return [
        {
          id: 'workflow',
          title: 'Guided workflow',
          description: 'Step-by-step overview of the full subscription pipeline.',
          path: '/admin-subscriptions/workflow',
          icon: <FiPlay size={28} />,
          accent: '#0048e6',
        },
        ...stepCards,
      ];
    }

    return stepCards;
  }, []);

  const pageSubtitle = role
    ? `Plans, contracts, payments, and billing · ${role.replace(/_/g, ' ')}`
    : 'Plans, contracts, payments, and billing — sign in as Hr, ProjectManager, or AdminController';

  return (
    <DashboardCardGrid
      pageTitle="Admin Subscriptions"
      pageSubtitle={pageSubtitle}
      cardData={cardData}
      filterByRole={false}
    />
  );
}
